import { call, put, takeLatest } from 'redux-saga/effects';
import { OK } from 'http-status-codes';
import { safeResolveAsync } from '../../utils/saga';

import { types, actions } from './duck';
import { getPreferences, updatePreferences } from './api';

export function* getPreferencesSaga() {
  try {
    yield put(actions.getPreferencesRequest());
    const response = yield call(getPreferences);

    if (response.status === OK) {
      yield put(actions.getPreferencesSuccess(response.data));
    } else {
      yield put(actions.getPreferencesFailure(response.statusText));
    }
  } catch (error) {
    yield put(actions.getPreferencesFailure(error.message));
  }
}

export function* updatePreferencesSaga({ data, resolve }) {
  try {
    yield put(actions.updatePreferencesRequest());
    const response = yield call(updatePreferences, data);

    if (response.status === OK) {
      yield put(actions.updatePreferencesSuccess(response.data));
      yield safeResolveAsync(resolve);
    } else {
      const error = (response.data && response.data.errors) || response.statusText;
      yield put(actions.updatePreferencesFailure(error));
      yield safeResolveAsync(resolve, { submitError: error });
    }
  } catch (error) {
    yield put(actions.updatePreferencesFailure(error.message));
    yield safeResolveAsync(resolve, { submitError: error.message });
  }
}

export default function* saga() {
  yield takeLatest(types.GET_PREFERENCES, getPreferencesSaga);
  yield takeLatest(types.UPDATE_PREFERENCES, updatePreferencesSaga);
}
